import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation';
import Content from './components/Content';
import Footer from './components/Footer';
import './App.css';
import { ToastProvider } from "./context/ToastContext";
import { AnalyticsService } from './services/analytics.service';

// Separate component for analytics tracking
const AnalyticsWrapper: React.FC = () => {
    const location = useLocation();
    const analytics = AnalyticsService.getInstance();

    useEffect(() => {
        // Initialize GA4
        const measurementId = process.env.REACT_APP_GA4_MEASUREMENT_ID;
        if (measurementId) {
            analytics.init(measurementId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Analytics is a singleton, no need to include in deps

    useEffect(() => {
        // Track page changes
        analytics.pageView(location.pathname + location.search);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]); // Analytics is a singleton, no need to include in deps

    return null;
};

const App = () => {
    return (
        <HelmetProvider>
            <Router>
                <ToastProvider>
                    <AnalyticsWrapper />
                    <div className="grid-container">
                        <Navigation />
                        <Content />
                        <Footer />
                    </div>
                </ToastProvider>
            </Router>
        </HelmetProvider>
    );
};

export default App;
